import { Modal, Button, Form, notification } from "antd";

import { useEffect } from "react";
import FloatInput from "../../../../providers/FloatInput";
import { POST, GET } from "../../../../providers/useAxiosQuery";
import validateRules from "../../../../providers/validateRules";

export default function ModalAddCourse(props) {
	const { setToggleModalCourse, setToggleModalCourses } = props;
	const [form] = Form.useForm();

	const { mutate: mutateEmail, loading: loadingEmail } = POST(
		`api/ref_courses`,
		"add_courses"
	);

	const onFinish = (values) => {
		console.log("onFinish", values);

		let data = {
			...values,

			id:
				setToggleModalCourse.data && setToggleModalCourse.data.id
					? setToggleModalCourse.data.id
					: "",
		};

		mutateEmail(data, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "Course Added",
						description: res.message,
					});

					setToggleModalCourses({ open: false, data: null });

					form.resetFields();
				} else {
					notification.error({
						message: "Something went wrong",
						description: res.message,
					});
				}
			},
			onError: (err) => {
				notification.error({
					message: "Course not Added",
					description: "Something went Wrong",
				});
			},
		});
	};

	useEffect(() => {
		if (setToggleModalCourse.open) {
			form.setFieldsValue({
				...setToggleModalCourse.data,
			});
		}

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [setToggleModalCourse]);

	return (
		<Modal
			title="Add Course"
			open={setToggleModalCourse.open}
			onCancel={() => {
				setToggleModalCourses({
					open: false,
					data: null,
				});
			}}
			footer={[
				<Button
					className="btn-main-primary outlined"
					size="large"
					key={1}
					onClick={() => {
						setToggleModalCourses({
							open: false,
							data: null,
						});
						form.resetFields();
					}}
				>
					CANCEL
				</Button>,
				<Button
					className="btn-main-primary"
					type="primary"
					size="large"
					key={2}
					onClick={(values) => form.submit(values)}
					loading={loadingEmail}
				>
					SUBMIT
				</Button>,
			]}
		>
			<Form form={form} onFinish={onFinish}>
				<Form.Item name="course_name">
					<FloatInput label="Course" placeholder="Course" required />
				</Form.Item>
			</Form>
		</Modal>
	);
}
